import { Injectable } from '@angular/core';
import { Location } from '@angular/common';

import { Menu } from './menu.model';
import { verticalMenuItems, horizontalMenuItems } from './menu';
import { httpConnect } from 'src/app/services/httpConnect.service';
import { AppOAuthStore } from '../../../models/AppOAuthSotarge';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { AppSettings } from 'src/app/app.settings';
import { Settings } from '../../../app.settings.model';

@Injectable()
export class MenuService {
  connectSvc: httpConnect;
  menus : Array<Menu> = verticalMenuItems;
  settings: Settings;

  constructor(private location:Location, private httpConn : httpConnect,
              public myStorage: AppOAuthStore, private appSettings: AppSettings){ 
    this.connectSvc = httpConn;
    this.settings = appSettings.settings;
  }
    
  getVerticalMenuItems(): Observable<Array<Menu>> {
    // return this.getMenus()
    // .pipe(
    //   map((data) => {
          try{
              let data = JSON.parse(this.myStorage.getItem('permisos'));
              if( data != null) {
                  let menu = data;
                  let menusFiltrados = this.menus.filter(m => { 
                              return menu.map(mm => mm.desc_modulo + ' / ' + mm.desc_permiso).includes(m.id_menu) || m.parentId == 0
                            });
                  let _menus = menusFiltrados.map(m => ({id : m.id, parentId : m.parentId})).filter(m => m.parentId != 0).map(m => m.parentId)
                  if(typeof _menus === 'object' && _menus.length > 0){
                    menusFiltrados = menusFiltrados.filter(m => _menus.includes(m.id) || _menus.includes(m.parentId));
                  }
                  // this.myStorage.removeItem("permisos");
                  // this.myStorage.setItem("permisos", JSON.stringify(menu));
                  return of(menusFiltrados);
              }else{
                  return of(null);
              }
          }catch(e){
              return of(null);
          }
      // })
    // )
  }

  getMenus() : Observable<any>{
    let parms: {} = {
      id_perfil: parseInt(this.myStorage.getItem("id_perfil"))
    }
     return this.connectSvc.postLogAPI('Seguridad','ListPermisos' , parms)
  }

  getHorizontalMenuItems():Array<Menu> {
    return horizontalMenuItems;
  }

  expandActiveSubMenu(menu:Array<Menu>){
      let url = this.location.path();
      let routerLink = url; // url.substring(1, url.length);
      let activeMenuItem = menu.filter(item => item.routerLink === routerLink);
      if(activeMenuItem[0]){
        let menuItem = activeMenuItem[0];
        while (menuItem.parentId != 0){  
          let parentMenuItem = menu.filter(item => item.id == menuItem.parentId)[0];
          menuItem = parentMenuItem;
          this.toggleMenuItem(menuItem.id);
        }
      }
  }

  toggleMenuItem(menuId, parentId = null){
    let menuItem = document.getElementById('menu-item-'+menuId);
    let subMenu = document.getElementById('sub-menu-'+menuId);  
    if(subMenu){
      if(subMenu.classList.contains('show')){
        subMenu.classList.remove('show');
        menuItem.classList.remove('expanded');
        setTimeout(() => {this.settings.menuType = 'mini'}, 400);
      }
      else{
        setTimeout(() => {
          subMenu.classList.add('show');
          menuItem.classList.add('expanded');
        }, 400);
        this.settings.menuType = 'compact';
      }      
    }
    else {
      if (parentId != null) {
        let menuItem2 = document.getElementById('menu-item-'+parentId);
        let subMenu2 = document.getElementById('sub-menu-'+parentId);          
        if(subMenu2.classList.contains('show')){
          subMenu2.classList.remove('show');
          menuItem2.classList.remove('expanded');
          this.settings.menuType = 'mini';
        }         
      }
    }
  }

  closeOtherSubMenus(menu:Array<Menu>, menuId){
    let currentMenuItem = menu.filter(item => item.id == menuId)[0]; 
    if(currentMenuItem.parentId == 0 && !currentMenuItem.target){
      menu.forEach(item => {
        if(item.id != menuId){
          let subMenu = document.getElementById('sub-menu-'+item.id);
          let menuItem = document.getElementById('menu-item-'+item.id);
          if(subMenu){
            if(subMenu.classList.contains('show')){
              subMenu.classList.remove('show');
              menuItem.classList.remove('expanded');
            }              
          } 
        }
      });
    }
  }

  closeAllSubMenus(){
      let menu = document.getElementById("vertical-menu");
      if(menu){
          for (let i = 0; i < menu.children[0].children.length; i++) {
              let child = menu.children[0].children[i];
              if(child){
                  if(child.children[0].classList.contains('expanded')){
                      child.children[0].classList.remove('expanded');
                      child.children[1].classList.remove('show');
                  }
              }
          }
      }
  }
  

}
